/* eslint-disable */
import React from 'react';

const UpdatedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6624 4.25086C18.0762 4.6167 18.115 5.24867 17.7492 5.66242L8.90705 15.6624C8.72004 15.8739 8.45234 15.9965 8.17004 15.9999C7.88774 16.0034 7.61714 15.8873 7.42505 15.6804L2.26716 10.1248C1.89139 9.72011 1.91487 9.08738 2.31961 8.71161C2.72435 8.33584 3.35708 8.35932 3.73285 8.76406L8.13982 13.5108L16.2509 4.33761C16.6167 3.92387 17.2487 3.88503 17.6624 4.25086Z" fill="white" />
    </svg>
);

export default UpdatedIcon;